import { Link } from "react-router-dom";
import type { Movie } from "@/types/media";
import { typeLabels } from "@/utils/media";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={movie.title}
          title={`${movie.title} 在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {typeof rank === "number" && (
          <span className="absolute top-0 left-0 min-w-8 h-8 px-2 flex items-center justify-center rounded-br-lg bg-primary-500 text-foreground-950 font-heading font-extrabold text-sm">
            {rank}
          </span>
        )}

        {movie.rating > 0 && (
          <span className="absolute top-2 right-2 h-7 px-2 flex items-center gap-1 rounded-md bg-foreground-950/70 backdrop-blur-sm text-primary-400 text-xs font-semibold">
            <i className="ri-star-fill text-xs"></i>
            {movie.rating.toFixed(1)}
          </span>
        )}

        <span className="absolute bottom-2 left-2 h-6 px-2 flex items-center rounded bg-foreground-950/70 backdrop-blur-sm text-background-50 text-[11px] font-medium">
          {movie.status}
        </span>

        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-foreground-950">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </span>
      </div>

      <div className="p-3">
        <h3 className="font-heading font-bold text-sm md:text-[15px] text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 truncate">
          {typeLabels[movie.type]} · {movie.genres.slice(0, 2).join(" / ")}
        </p>
        <p className="mt-1 text-xs text-foreground-400 truncate">
          {movie.region} · {movie.year}
        </p>
      </div>
    </Link>
  );
}